import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import * as types from '@/store/types';
import { mapGetters, mapMutations } from 'vuex';

@Component({
  computed: mapGetters({
    validDomain: types.VALID_DOMAIN,
    recipientWithStatus: types.RECIPIENTS_WITH_STATUS_GET,
  }),
  methods: mapMutations({
    changeRecipientSelect: types.RECIPIENTS_WITH_STATUS_SELECT_CHANGE,
  }),
})
export default class RecipientItem extends Vue {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  validDomain!: string[];
  recipientWithStatus!: RecipientWithStatus[];

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  changeRecipientSelect!: (payload: RecipientWithStatus) => void;

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: C O M P U T E D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //
  get sentStatusColor() {
    if (this.isExternal) {
      return 'gray';
    }

    switch (this.item.mailStatus) {
      case 'NotFound':
        return 'gray';
      case 'NotRead':
        return 'blue';
      case 'Read':
        return 'green';
      case 'Error':
        if (this.item.error == 'ErrorNonExistentMailbox' || this.item.error == 'ErrorInvalidLicense') {
          return 'gray';
        } else {
          return 'red';
        }
    }
  }

  get sentStatusText() {
    if (this.isExternal) {
      return '외부메일';
    }

    switch (this.item.mailStatus) {
      case 'NotFound':
        return '메일없음';
      case 'Read':
        return '수신확인';
      case 'NotRead':
        return '발송완료';
      case 'Error':
        if (this.item.error == 'ErrorNonExistentMailbox') {
          return '사서함없음';
        } else if (this.item.error == 'ErrorInvalidLicense') {
          return '라이센스없음';
        } else {
          return '실패';
        }
    }
  }

  get recallStatusColor() {
    switch (this.item.recallStatus) {
      case 'Ready':
        return 'outline-gray';
      case 'Success':
        return 'outline-blue';
      default:
        if(this.item.recallStatus !== null && this.item.recallStatus !== undefined) {
          return 'outline-red';
        }
    }
  }

  get recallStatusText() {
    switch (this.item.recallStatus) {
      case 'Ready':
        return '요청중';
      case 'Success':
        return '회수완료';
      default:
        if(this.item.recallStatus !== null && this.item.recallStatus !== undefined) {
          return '실패';
        }
    }
  }

  get isExternal() {
    const domain = this.item.recipient.toLowerCase().split('@')[1];
    const isValidDomain = this.validDomain.findIndex(x => x == domain) > -1;

    return !isValidDomain;
  }

  get isSelectable() {
    if (!this.isExternal && !this.item.recallStatus && this.item.mailStatus !== 'NotFound') {
      return true;
    }
    return false;
  }

  get displayDate() {
    if (this.item.receivedDate) {
      const inputDate = new Date(this.item.receivedDate);
      const year = inputDate.getFullYear();
      const month = String(inputDate.getMonth() + 1).padStart(2, '0');
      const day = String(inputDate.getDate()).padStart(2, '0');
      const hours = inputDate.getHours();
      const convertedHours = hours % 12 == 0 ? 12 : hours % 12;
      const minutes = String(inputDate.getMinutes()).padStart(2, '0');

      const period = hours < 12 ? this.$t('오전').toString() : this.$t('오후').toString();

      const formattedDate = `${year}-${month}-${day} ${period} ${convertedHours}:${minutes}`;
      return formattedDate;
    }
  }

  get displayNameEmail() {
    return `${this.item.displayName} (${this.item.recipient})`;
  }

  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //
  @Prop({ type: Object }) item!: RecipientWithStatus;

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //
  handleSelect() {
    this.changeRecipientSelect(this.item);
  }
}